"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIdentifier = exports.getTokenMetadataByMintAddress = void 0;
const anchor_1 = require("@project-serum/anchor");
const parseData_1 = require("./parseData");
const crc32 = __importStar(require("crc-32"));
const METADATA_PROGRAM_ID = 'metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s';
const metadataProgramId = new anchor_1.web3.PublicKey(METADATA_PROGRAM_ID);
const getTokenMetadataByMintAddress = async function (mintAddress, connection) {
    var _a;
    const [newEditionMetadata] = await anchor_1.web3.PublicKey.findProgramAddress([Buffer.from('metadata'), metadataProgramId.toBuffer(), new anchor_1.web3.PublicKey(mintAddress).toBuffer()], metadataProgramId);
    const newEditionMetadataAccountInfo = await connection.getAccountInfo(newEditionMetadata);
    const metadata = (0, parseData_1.parseMetadata)(newEditionMetadataAccountInfo.data).data;
    return {
        // @ts-ignore
        creators: (_a = metadata.creators) === null || _a === void 0 ? void 0 : _a.map((creator) => ({
            address: new anchor_1.web3.PublicKey(creator.address).toString(),
            verified: creator.verified,
            share: creator.share
        })),
        symbol: metadata.symbol,
        metadataAddress: newEditionMetadata.toString(),
        sellerFeeBasisPoints: metadata.sellerFeeBasisPoints
    };
};
exports.getTokenMetadataByMintAddress = getTokenMetadataByMintAddress;
const getIdentifier = async (mintAddress, connection) => {
    try {
        const { symbol, creators, metadataAddress } = await (0, exports.getTokenMetadataByMintAddress)(mintAddress, connection);
        const str = symbol + JSON.stringify(creators);
        const identifier = crc32.str(str);
        console.log('metadata', metadataAddress);
        console.log('creators', JSON.stringify(creators));
        console.log('symbol', symbol);
        console.log('identifier', identifier);
        console.log('metadataAddress', metadataAddress);
    }
    catch (e) {
        console.error(e);
    }
};
exports.getIdentifier = getIdentifier;
